import getArrayFromQueryParam from "./getArrayFromQueryParam";
import { QueryParamDropdownListT } from "./useQueryParamDropdown";

const getSelectedFromList = (
  list: QueryParamDropdownListT,
  getQueryParam: (param: string) => string | null
) => {
  let res: any = {};
  Object.keys(list).forEach((qp) => {
    const values = getArrayFromQueryParam(getQueryParam(qp)!);
    res[qp] = values;
  });

  return res;
};

export default getSelectedFromList;